'use client';

import HomepageTemplate from "@src/components/templates/homepage-office";

const Company = (detail) => {

  return (<HomepageTemplate {...detail} />)
}

export default Company
